import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslateUtil {
  constructor(private translateService: TranslateService) {}

  public translate(key: string | Array<string>, params: any = {}): any {
    return this.translateService.instant(key, params);
  }

  public async translations(
    key: string | Array<string>,
    params: any = {}
  ): Promise<string[]> {
    return firstValueFrom(this.translateService.get(key, params)).then(
      translations => Object.values(translations)
    );
  }
}
